import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

export default class Multiselect extends Component {
  menuItems() {
    const { options, value } = this.props;

    return options.map((item) => (
      <MenuItem
        key={item.value}
        insetChildren
        checked={value.includes(item.value)}
        value={item.value}
        primaryText={item.label}
      />
    ));
  }

  selectionRenderer = () => {
    const { value } = this.props;

    switch (value.length) {
      case 0:
        return '';
      case 1:
        return `${value.length} item selected`;
      default:
        return `${value.length} items selected`;
    }
  };

  render() {
    return (
      <SelectField selectionRenderer={this.selectionRenderer} multiple {...this.props}>
        {this.menuItems()}
      </SelectField>
    );
  }
}



// WEBPACK FOOTER //
// ./components/atoms/Multiselect.js